import React from 'react';
import { Button } from '@makemydeal/dr-ui-bricks-components';
import { SendRequestButtonContainer } from './SendRequestButton.styles';
import type { SendRequestButtonProps } from '../../types';

const SendRequestButton: React.FC<SendRequestButtonProps> = ({ isSubmitting, onClick }) => {
    return (
        <SendRequestButtonContainer>
            <Button buttonStyle="primary" disabled={isSubmitting} onClick={onClick} data-testid="send-request-button">
                Send Request
            </Button>
        </SendRequestButtonContainer>
    );
};

export default SendRequestButton;
